import {CLOSETS, REGION} from '../const';

/**
 * @param filter
 * @param tabId
 * @returns {{}}
 */
export const prepareFilter = (filter = {}, tabId) => {
    const requestFilter = { ...filter };
    if (tabId === CLOSETS) {
        requestFilter.regionId = null;
    } else if (tabId === REGION) {
        requestFilter.lat = null;
        requestFilter.lng = null;
    }

    return requestFilter;
}



// WEBPACK FOOTER //
// ./src/components/locator/helpers/filter.js